import React, { useMemo } from "react"
import { Tag, Icon, Intent, IconName } from "@blueprintjs/core"
import { startCase } from "lodash-es"
const PermissionIcon = ({ permission }) => {
  const iconProps: { icon: IconName; intent: Intent } = useMemo(() => {
    if (permission.type === "edit") {
      return { icon: "edit", intent: Intent.SUCCESS }
    } else if (permission.type === "delete") {
      return { icon: "trash", intent: Intent.DANGER }
    } else {
      return { icon: "eye-open", intent: Intent.PRIMARY }
    }
  }, [permission])
  return (
    <div>
      <Tag
        className="mr-2 py-1"
        minimal={true}
        round={true}
        intent={iconProps.intent}
      >
        <span>
          <Icon className="mr-1" icon={iconProps.icon} />
          {startCase(permission.name)}
        </span>
      </Tag>
    </div>
  )
}

export default PermissionIcon
